import * as Msdyn365 from '@msdyn365-commerce/core';
import * as React from 'react';
import { useState } from 'react';
import getSoldTosAction, { GetSoldTosInput, ISoldToTableData } from '../../../actions/create-order/get-sold-tos.action';
import { useModal } from '../../../components/modal';
import { ProductRequestModalContent } from '../../lxs-product-request-modal/lxs-product-request-modal';
import { ILxsProductRequestModalResources } from '../../lxs-product-request-modal/lxs-product-request-modal.props.autogenerated';

interface IProductRequestButtonProps {
    buttonText: string;
    actionContext: Msdyn365.IActionContext;
    resources: ILxsProductRequestModalResources;
    CLASS_NAME?: string;
    user?: {
        firstName?: string;
        lastName?: string;
        emailAddress?: string;
        name?: string;
    };
}

const ProductRequestButton: React.FC<IProductRequestButtonProps> = ({ buttonText, actionContext, resources, user, CLASS_NAME }) => {
    const { setOpen, setClose } = useModal();
    const [isLoading, setIsLoading] = useState(false);

    const handleClick = async () => {
        setIsLoading(true);
        let soldTos: ISoldToTableData[] | undefined;

        try {
            const getSoldTosResponse = await getSoldTosAction(new GetSoldTosInput(), actionContext);
            const soldToTableData: ISoldToTableData[] | undefined = getSoldTosResponse?.result?.value;
            if (soldToTableData && soldToTableData.length > 0) {
                soldTos = soldToTableData;
            }
        } catch {
            console.error('Error fetching sold-to data');
        }

        setIsLoading(false);

        setOpen({
            content: (
                <ProductRequestModalContent
                    onClose={setClose}
                    actionContext={actionContext}
                    user={user}
                    soldTos={soldTos}
                    resources={resources}
                />
            ),
            size: 'xl'
        });
    };

    return (
        <div className={`${CLASS_NAME}__cta ${CLASS_NAME}__cta--button`}>
            <span className={`${CLASS_NAME}__cta-item ${CLASS_NAME}__cta-item--button`}>
                <button className={`msc-cta__primary ${CLASS_NAME}__cta-button`} type='button' onClick={handleClick} disabled={isLoading}>
                    {buttonText}
                </button>
            </span>
        </div>
    );
};

export default ProductRequestButton;
